<template>
  <div>
    <header>
      <HeaderPhotobook />
      <BreadcrumbList />
    </header>
    <div class="contentsBox">
      <div id="photobookExhibition" class="photobookBox">
        <section id="photobookExhibitionTitle">
          <div class="inner4">
            <h1><small>東京カメラ部2020写真展 公式写真集</small><br>「それでも世界は美しい。」<br>発売記念10選2019作品プリント展示</h1>
            <h2><span>三省堂書店有楽町店</span> <span>MARUZEN＆ジュンク堂書店 梅田店</span></h2>
          </div>
        </section>
        <section id="photobookExhibitionIntro">
          <div class="inner4">
            <p>本写真展公式写真集を発刊していただく日経ナショナル ジオグラフィック社さんのご協力によって、10選2019の皆様の10選選出作品（合計10作品）の展示（A2サイズ）を「八重洲ブックセンター本店」「MARUZEN＆ジュンク堂書店梅田店」にて開催いただけることとなりました。本来であれば、10選2019の皆様のすべての作品や他の出展者の方々の作品も展示したいところですが、COVID-19感染症対策やスペースの関係でこれは叶いませんでした。力不足で申し訳ございません。あくまでも感染症対策を最優先としておりますので、この点、どうかご理解とご容赦ください。</p>
          </div>
        </section>
        <section id="photobookExhibitionYaesu" class="photobookExhibitionVenue">
          <div class="inner4">
            <h2>東京</h2>
            <h3>八重洲ブックセンター本店</h3>
            <h4>2020年9月16日～10月25日（予定）</h4>
            <h5>会場：3F壁面ギャラリースペース</h5>
            <p class="note">※イレギュラーな輸送状況が発生した場合、予定日に新刊が書店に並ばないこともあるため、開催が遅れることもございます。ご了承ください。</p>
            <img src="/img/photobookExhibitionVenueYaesu.jpg" alt="八重洲ブックセンター本店での展示風景">
            <p class="venueInfo">
<b>書店情報</b><br>
住所: 〒104-8456 東京都中央区⼋重洲2-5-1 TEL︓03-3281-8203<br>
営業時間: 月～土 11:00～20:00／日・祝日 11:00～19:00（営業休⽌フロア︓B1階）<br>
URL: <a class="wrap" target="_blank" href="https://www.yaesu-book.co.jp/">https://www.yaesu-book.co.jp/</a>
            </p>
          </div>
        </section>
        <section id="photobookExhibitionUmeda" class="photobookExhibitionVenue">
          <div class="inner4">
            <h2>大阪</h2>
            <h3>MARUZEN＆ジュンク堂書店 梅田店</h3>
            <h4>2020年9月19日～10月18日（予定）</h4>
            <h5>会場：5F 芸術書 検索機前通路スペース</h5>
            <p class="note">※イレギュラーな輸送状況が発生した場合、予定日に新刊が書店に並ばないこともあるため、開催が遅れることもございます。ご了承ください。</p>
            <img src="/img/photobookExhibitionVenueUmeda.jpg" alt="MARUZEN＆ジュンク堂書店 梅田店での展示風景">
            <p class="venueInfo">
<b>書店情報</b><br>
住所: 〒530-0013 ⼤阪府⼤阪市北区茶屋町7-20 チャスカ茶屋町 地下1階〜7階 TEL︓06-6292-7383<br>
営業時間: 10:00～21:00<br>
URL: <a class="wrap" target="_blank" href="https://honto.jp/store/detail_1570065_14HB320.html">https://honto.jp/store/detail_1570065_14HB320.html</a>
            </p>
          </div>
        </section>
        <section id="photobookIntro">
          <div class="inner4">
            <PhotobookIntro />
          </div>
        </section>
        <PhotobookSeries />
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import HeaderPhotobook from '@/components/modules/HeaderPhotobook.vue'
import BreadcrumbList from '@/components/modules/BreadcrumbList.vue'
import PhotobookIntro from '@/components/modules/PhotobookIntro.vue'
import PhotobookSeries from '@/components/modules/PhotobookSeries.vue'
import Footer from '@/components/modules/Footer.vue'

export default {
  components: {
    HeaderPhotobook,
    BreadcrumbList,
    PhotobookIntro,
    PhotobookSeries,
    Footer
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.contentsBox {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
